import { StrictMode } from 'react'
import * as ReactDOM from 'react-dom/client'

import App from './app/app'

declare let __webpack_public_path__: string | undefined

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <StrictMode>
    <App publicPath={__webpack_public_path__} />
  </StrictMode>
)
